
import axios from '@/axios.js'

export default {
  setProgressSearchQuery ({ commit }, query) {
    commit('SET_PROGRESS_SEARCH_QUERY', query)
  },
  // TASK
    fetchTasks ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`/task-list-pelaksanaan-pekerjaan/${payload.pelaksanaan}/${payload.filter}`)
        //axios.post('/task-list-pelaksanaan-pekerjaan',payload)
          .then((response) => {
            commit('SET_TASKS', response.data.data.tasks)
            commit('SET_TAGS', response.data.data.taskTags)
            commit('SET_RAB', response.data.data.rab)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },

    fetchBiaya ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`/task-list-pelaksanaan-rekap/${payload}`)
        .then((response) => {
          commit('SET_BIAYA', response.data.data.tasks)
          commit('SET_PELAKSANAAN', response.data.data.pelaksanaan)
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
    },

    fetchKalender ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`/task-list-pelaksanaan-rekap-tanggal/${payload}`)
        .then((response) => {
          commit('SET_EVENT', response.data.data.tasks)
          commit('SET_PELAKSANAAN', response.data.data.pelaksanaan)
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
    },

    fetchAHSP ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`/get-analisa-fix/${payload}`)
          .then((response) => {
            commit('SET_AHSP', response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },

  // ACTIVITY
    fetchActivity ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`/get-activities-fix/${payload.unit}/${payload.id}/${payload.rab}`)
          .then((response) => {
            commit('SET_ACTIVITIES', response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },

    addUpdate ({ commit }, task) {
      return new Promise((resolve, reject) => {
        axios.post('/task-add-pelaksanaan-update', task)
        .then((response) => {
          commit('ADD_UPDATE', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },
    
    removeUpdate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/task-remove-pelaksanaan-update', data)
        .then((response) => {
          commit('REMOVE_UPDATE', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

  // TAG
    addTag ({ commit }, tag) {
      return new Promise((resolve, reject) => {
        axios.post('/term-add', tag)
          .then((response) => {
            commit('ADD_TAG', response.data.data)
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },

    setTags ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/set-tags', payload)
      .then((response) => {
        commit('UPDATE_TAGS', payload)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
}
